import { apiFetch } from "../auth/apiClient";

export const directoryApi = {
  // Categories
  listCategories: () =>
    apiFetch("/api/directory/categories", { method: "GET", authRequired: true }),
  createCategory: (name) =>
    apiFetch("/api/directory/categories", {
      method: "POST",
      authRequired: true,
      body: { name },
    }),
  patchCategory: (id, body) =>
    apiFetch(`/api/directory/categories/${id}`, {
      method: "PATCH",
      authRequired: true,
      body,
    }),
  deleteCategory: (id) =>
    apiFetch(`/api/directory/categories/${id}`, {
      method: "DELETE",
      authRequired: true,
    }),

  // Contacts
  listContacts: ({ category, q, communityPick } = {}) => {
    const params = new URLSearchParams();
    if (category) params.set("category", category);
    if (q) params.set("q", q);
    if (communityPick !== undefined)
      params.set("community_pick", String(communityPick));
    const qs = params.toString();
    return apiFetch(
      `/api/directory/contacts${qs ? `?${qs}` : ""}`,
      { method: "GET", authRequired: true }
    );
  },
  getContact: (id) =>
    apiFetch(`/api/directory/contacts/${id}`, {
      method: "GET",
      authRequired: true,
    }),
  createContact: (body) =>
    apiFetch("/api/directory/contacts", {
      method: "POST",
      authRequired: true,
      body,
    }),
  patchContact: (id, body) =>
    apiFetch(`/api/directory/contacts/${id}`, {
      method: "PATCH",
      authRequired: true,
      body,
    }),
  deleteContact: (id) =>
    apiFetch(`/api/directory/contacts/${id}`, {
      method: "DELETE",
      authRequired: true,
    }),

  // Reviews
  upsertReview: (contactId, body) =>
    apiFetch(`/api/directory/contacts/${contactId}/reviews`, {
      method: "POST",
      authRequired: true,
      body,
    }),
  deleteMyReview: (contactId) =>
    apiFetch(`/api/directory/contacts/${contactId}/reviews/me`, {
      method: "DELETE",
      authRequired: true,
    }),
  deleteReview: (contactId, reviewId) =>
    apiFetch(`/api/directory/contacts/${contactId}/reviews/${reviewId}`, {
      method: "DELETE",
      authRequired: true,
    }),

  // Admin
  adminListContacts: ({ q, page = 1, pageSize = 50 } = {}) => {
    const params = new URLSearchParams({
      page: String(page),
      page_size: String(pageSize),
    });
    if (q) params.set("q", q);
    return apiFetch(`/api/directory/admin/contacts?${params.toString()}`, {
      method: "GET",
      authRequired: true,
    });
  },
};

export function formatPhone(raw) {
  if (!raw) return "";
  const digits = String(raw).replace(/\D/g, "").slice(-10);
  if (digits.length !== 10) return raw;
  return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
}

export function waLink(phone) {
  const digits = String(phone || "").replace(/\D/g, "").slice(-10);
  if (!digits) return "#";
  return `https://wa.me/91${digits}`;
}

export function telLink(phone) {
  const digits = String(phone || "").replace(/\D/g, "").slice(-10);
  if (!digits) return "#";
  return `tel:+91${digits}`;
}

export function mailLink(email) {
  return email ? `mailto:${email}` : "#";
}
